import { ImportHistoryDto, ImportResultDto } from '../../../models/employeeHub';
import { BackendHttpService } from '../../../services/backendHttpService';

class EmployeeImportService extends BackendHttpService {
    constructor() {
        super('api/employee-import');
    }

    async importEmployees(file: File, autoCreateDictionaries = true, importDate?: string): Promise<ImportResultDto> {
        const formData = new FormData();
        formData.append('file', file);
        const params = new URLSearchParams();
        params.set('autoCreateDictionaries', String(autoCreateDictionaries));
        if (importDate) {
            params.set('importDate', importDate);
        }
        return this.postFormData<FormData, ImportResultDto>(formData, `?${params.toString()}`);
    }

    getHistory(count = 10): Promise<ImportHistoryDto> {
        return this.get<ImportHistoryDto>(`/history?count=${count}`);
    }
}

export const employeeImportService = new EmployeeImportService();
